"use strict";
var debounce = require("lodash/debounce");

module.exports = {
    init: function () {
        const $elements = $(".c-anniversary-secondary-banner");

        if ($elements.length === 0 || !window.mqRespond.status.lgDown) {
            return;
        }

        $(document).on("scroll", debounce(function () {
            const viewportHeight = window.innerHeight;

            $elements.each(function () {
                const $element = $(this);

                if (!$element.hasClass("touch-active")) {
                    const elementTop = $element.offset().top;
                    const elementHeight = $element.outerHeight();
                    const scrollTop = $(window).scrollTop();
                    const elementMiddle = elementTop - scrollTop + elementHeight / 2;
                    const isInMiddle = (elementMiddle + 20) >= (viewportHeight / 2 - elementHeight / 2) && (elementMiddle - 20) <= (viewportHeight / 2 + elementHeight / 2);
                    $element.toggleClass("active", isInMiddle);
                }
            });
        }, 10));

        $elements.on("touchstart touchend", function (e) {
            let activeFlag = e.type === "touchstart";

            if (activeFlag) {
                $elements.toggleClass("active", false).toggleClass("touch-active", true);
                $(this).toggleClass("active", true);
            } else {
                $elements.toggleClass("touch-active", false);
                $(document).trigger("scroll");
            }
        });

        $elements.find("a").on("click", function () {
            $elements.toggleClass("active", false).toggleClass("touch-active", true);
            $(this).closest(".c-anniversary-secondary-banner").toggleClass("active", true);
        });
    }
};
